import http from '../../core/services/http'

export const generateScrapingEngineReport = ({ userIds, startDate, endDate }) =>
  http.get(
    `/reports/scraping-engine?userIds=${userIds}&startDate=${startDate}&endDate=${endDate}`,
    { responseType: 'blob' },
  )
